import React from 'react'
import './App.css'
import Main from './components/pages/Main/Main'
import { Providers } from './Providers'
import MainLayout from './components/layouts/MainLayout'
import TelegramProvider from './TelegramProvider'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Contacts from './components/pages/Contacts/Contacts'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <MainLayout>
        <Main />
      </MainLayout>
    ),
  },
  {
    path: 'contacts',
    element: (
      <div style={{ padding: 16 }}>
        <Contacts />
      </div>
    ),
  },
])

function App() {
  return (
    <Providers>
      <TelegramProvider>
        <RouterProvider router={router} />
      </TelegramProvider>
    </Providers>
  )
}

export default App
